import { render, staticRenderFns } from "./BusinessMemberPrescriptionInviteToPlan.vue?vue&type=template&id=2065f3ce"
import script from "./BusinessMemberPrescriptionInviteToPlan.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPrescriptionInviteToPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports